// aptoken/frontend/src/App.js

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useSearchParams } from 'react-router-dom';
import '../viewToken.css';

const ViewToken = () => {
  const [tokens, setTokens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [params] = useSearchParams();
  const [programMetadata] = useState(null);

  // Supported modes: details | events
  const next = (params.get('next') || 'details').toLowerCase();
  const isTrackMode = next === 'events';

  const pageTitle = isTrackMode
    ? 'Track Provenance by Product Passport'
    : 'My Product Passports';

  const subTitle = isTrackMode
    ? 'Pick a product passport to view its provenance events.'
    : 'Pick a product passport to view its details.';

  useEffect(() => {
    const fetchTokens = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const res = await axios.get(`${apiUrl}/api/tokens`);

        setTokens(Array.isArray(res.data) ? res.data : []);
      } catch (err) {
        setError('Failed to fetch product passports.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchTokens();
  }, []);

  if (loading) return <p>Loading product passports...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className="container">
      <h2>{pageTitle}</h2>
      <p className="subhead">{subTitle}</p>

      <div className="grid">
        {tokens.length ? (
          tokens.map((token) => {
            const baseHref = `/tokens/${token.tokenId}`;

            const targetHref = isTrackMode
              ? `${baseHref}/events`
              : baseHref;

            const buttonText = isTrackMode
              ? 'Track Provenance →'
              : 'View Details →';

            return (
              <div
                className="archive-token-box"
                key={String(token.tokenId)}
              >
              <div className="program-information">
                <p>
                  <strong>Provenance Program:</strong>{' '}
                  {programMetadata?.name || 'Not specified'}
                </p>
              </div>
                <Link
                  to={targetHref}
                  className="token-box clickable-box"
                >
                  <p>
                    <strong>Passport ID:</strong> {token.tokenId}
                  </p>

                  <p>
                    <strong>Passport Name:</strong> {token.name}
                  </p>

                  <p>
                    <strong>Passport Description:</strong>{' '}
                    {token.description}
                  </p>

                  <p className="cta">{buttonText}</p>
                </Link>
              </div>
            );
          })
        ) : (
          <p>No product passports available.</p>
        )}
      </div>
    </div>
  );
};

export default ViewToken;